import getCountriesList from './getCountriesList';
import getDocumentTypeList from './getDocumentTypeList';
import getQuestionTypeList from './getQuestionTypeList';
import getRuleSets from './getRuleSets';
import getStatesList from './getStatesList';

const AssetsRequests = {
	getCountriesList,
	getStatesList,
	getRuleSets,
	getDocumentTypeList,
	getQuestionTypeList,
};

export default AssetsRequests;
